import { type IntegrationCredentialSummary } from "shared/types";
import { formatIntegrationLabel } from "utils/formatIntegrationLabel";

type SourceItem = {
  integration_credential?: IntegrationCredentialSummary | string | null;
  pms_id?: string | null;
};

export const getSourceLabel = (item?: SourceItem): string => {
  if (!item) return "Manually added";

  const credential = item.integration_credential;
  if (typeof credential === "string" && credential) return credential;
  if (credential && typeof credential === "object") {
    const label = formatIntegrationLabel(credential);
    if (label) return label;
  }

  if (item.pms_id) return "PMS";

  return "Manually added";
};
